import { useMultiStyleConfig } from '@chakra-ui/system';
import React from 'react';

import { forwardRef } from '../../system';

import DisplayNames from './enums';

import { MenuItem, MenuItemProps, Box } from 'index';

export type NavBarTabItemProps = MenuItemProps;

const NavBarTabItem = forwardRef<NavBarTabItemProps, 'div'>(
  (props: NavBarTabItemProps, ref): React.ReactElement => {
    const navBarTheme = useMultiStyleConfig('NavBarTheme', props);

    return (
      <Box __css={navBarTheme.navBarTabItem}>
        <MenuItem ref={ref} {...props} />
      </Box>
    );
  }
);

NavBarTabItem.displayName = DisplayNames.NavBarTabItem;

export default NavBarTabItem;
